var r="4.19.5";export{r as version};
//# sourceMappingURL=package.json.js.map
